<template>
  <tr>
    <td width="14%" class="px-1">
      <input
        type="number"
        class="input"
        @blur="updateKoli"
        @keydown.enter="focusRefs('focusPacking')"
        v-model="formData.koli"
        ref="focusKoli"
      />
    </td>
    <td width="14%" class="px-1">
      <input
        type="text"
        class="input"
        @blur="updatePacking"
        @keydown.enter="focusRefs('focusNama')"
        v-model="formData.packing"
        ref="focusPacking"
      />
    </td>
    <td width="70%" class="px-1">
      <input
        type="text"
        class="input"
        @blur="updateNamaBarang"
        @keydown.enter="$emit('focus-main')"
        v-model="formData.nama_barang"
        ref="focusNama"
      />
    </td>
    <td width="2%" class="px-1">
      <v-btn
        depressed
        color="error"
        @click="deleteData"
        :loading="loading"
        :disabled="loading"
        class="v-btn-small"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "FormDetil",
  props: ["data"],
  data() {
    return {
      formData: {
        id: this.data.id,
        koli: this.data.koli,
        packing: this.data.packing,
        nama_barang: this.data.nama_barang
      },
      loading: false
    };
  },
  methods: {
    async updateKoli() {
      if (Number(this.formData.koli || 0) <= 0) {
        return;
      }

      await axios
        .put(`update-ttb-detil/koli`, this.formData)
        .then(res => {
          this.$emit("update-koli");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async updatePacking() {
      await axios
        .put(`update-ttb-detil/packing`, this.formData)
        .then(res => {
          // // console.log(res.data);
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async updateNamaBarang() {
      await axios
        .put(`update-ttb-detil/nama-barang`, this.formData)
        .then(res => {
          // // console.log(res.data);
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async deleteData() {
      this.loading = true;

      await axios
        .delete(`ttb-detil/${this.data.id}`)
        .then(res => {
          this.loading = false;
          this.$emit("update-koli");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    }
  }
};
</script>

<style scoped>
.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.v-btn-small {
  height: 25px !important;
}
</style>
